import React from 'react'
import { useNavigate } from "react-router-dom";
import '../../Assets/Css/TestSuccess.css';
import TickIcon from '../../Assets/Images/Done_ring_round_fill.png';

const MedicineSuccess = () => {
    const navigate = useNavigate(); 
      return (
        <div className="test-success-container">
          <img src={TickIcon} alt="Success Tick Icon" className="tick-icon" />
          <p className="tsuccess-message">Your Test has been uploaded successfully!</p>
          <button className="thome-button" onClick={() => navigate('/home')}>Home</button>
        </div>
      );
    };
export default MedicineSuccess